import { Formik } from "formik";
import React from "react";
import  { useState } from "react";
import { toast } from "react-toastify";
import { Button, Form, Header, Segment } from "semantic-ui-react";
import MyTextInput from "../../../app/common/form/MyTextInput";
import { RecibosAgenciaFormValues, RecibosAgenciaMod } from "../../../app/models/PagoAgenciaMod";
import { useStore } from "../../../app/stores/store";
import "../CCTCuenta/pagar.css";


interface Props {
    cliente: any;
    cuenta: any; 
    saldo: any; 
    descripcion: any;  
   
    
    }

export default function ReciboPago(props: Props) {
    const {userStore: {user}, modalStore, PagoAgenciaStore, SGPersonaStore:{SGPersonaByName, loadSGPersona} } = useStore();
  
    const {createRecibosAgenciaMod, crearPdfReciboAgencia, PdfRecibo, loading, } = PagoAgenciaStore;
    const [RecibosAgenciaMod, setCCTipoDeDocumento] = useState<RecibosAgenciaFormValues>(new RecibosAgenciaFormValues());
   
    const nf = new Intl.NumberFormat("en-IN");    
    var date: Date = new Date()      
   

    var saldo = nf.format(props.saldo)
                            if((props.saldo % 1) == 0){
                                saldo = props.saldo + ".00"
                            }                         

                            function handleFormSubmit(ReciboAgenciaMod : RecibosAgenciaFormValues) {
                                let date: Date = new Date();
                                let id: any = user?.id;
                                let dpi: string|undefined 
                                let names: string|undefined
                                let apellidos: string|undefined
                                let nit: string|undefined   
                                                       
                             

                 loadSGPersona(id).then ( response=>{

                                    dpi = response?.dpi
                                    apellidos = response?.apellidos
                                    names = response?.nombres 
                                    nit= response?.nit
                                    var descripcion = props.descripcion;
                                    
                                                                      
                                    let newRecibo:RecibosAgenciaMod = {
                                         id: 0,
                                         idCliente: id,
                                         cuenta: props.cuenta,
                                         monto: props.saldo,          
                                         estado: "1",                                    
                                         fechaEmision: date,   
                                        
                                                                              
                                                                   
                                    };   


                                    createRecibosAgenciaMod(newRecibo, dpi, names, apellidos, nit, descripcion).then( response => {                                                                         
                                       
    
                                    
                                    toast.success("Se generó correctamente.")
                                
                                    modalStore.closeModal()
                                    });                               
                                  

                                });                               
                                                                       
                                                             
                                }                                                             
            

    return(

        <>

        <Segment className="modal_recibo">   

            < div className="contenido_pagoss">
                <div className="contenido_recibo">
                   
                <div className="monto"><b>Saldo Actual: </b><p>{"Q." + props.saldo.toFixed(2)}</p></div></div>
                <br></br> <br></br>
               
                {/* <p>{"Q" + props.cuenta.toFixed(2)}</p> */}
                <div className="datoss">                              
                
               
                <Formik 
                            enableReinitialize 
                            initialValues={RecibosAgenciaMod} 
                            onSubmit={values => handleFormSubmit(values)}>
                        {({handleSubmit, isValid, isSubmitting, dirty}) => (
                            <Form className='ui form' onSubmit={handleSubmit} autoComplete='off'>
                                <Header size='large' content='Datos para generar recibo de pago' style={{color:  "#538cbe", fontFamily: "Gotham", alingText:"center"}} />
                                <br></br>
                                <div style={{marginBottom: "10px"}} >
                                    <b>Ingrese el monto que desea pagar:</b> <MyTextInput name='monto' placeholder={props.saldo.toFixed(2)} type="number"  value={props.saldo.toFixed(2)} />
                
                                </div><br></br> 

                                 <div>                                   
                                    <b>Nombre del alumno:   </b><MyTextInput name='alumno' placeholder=''  value={user?.displayName}/>
                                </div> <br></br>                                                          
                                
                                 <div>                                                               
                                 <b>No.de cuenta:  </b><MyTextInput name='cuenta'  placeholder=''  value={String(props.cuenta)}/>
                                </div> <br></br>
                                <div>                                 
                                                                     
                                    <b>Descripicion  </b><MyTextInput name='descripcion' placeholder=''  value={props.descripcion}/>
                                
                                </div>  <br></br> 
                                
                               
                                 {/* <br></br> 
                             
                                <div id="fecha">
                                    <Header size="small" content="Fecha de Cobro Programado" />
                                    <MyDateInput name='fechaCobroProgramado' placeholderText='' dateFormat='dd/MM/yyyy' />
                                </div>                                                               
                               */}
                                <br></br>
                                <div>
                                    <Button
                                        loading={loading} 
                                        type='submit' 
                                        content='Generar recibo de pago' 
                                        style={{backgroundColor: "#15b3e8", color: "white"}}/>
                                       
                                </div>
                            </Form>
                        )}
                    </Formik>

                </div>
               
            </div>

            <br></br>
            <div className="botones_pago">                                                                      

                                                                                   
            </div>
         </Segment>
         </>
    )
}